import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 8l1 8l2 -5l2 5l1 -8","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-1"}]]

const IconSquareRoundedLetterW = createReactComponent('outline', 'square-rounded-letter-w', 'SquareRoundedLetterW', __iconNode);

export default IconSquareRoundedLetterW;